import React, { SyntheticEvent, FocusEvent, useState } from 'react';
import { useFormikContext } from 'formik';
import { Autocomplete, createFilterOptions, AutocompleteProps } from '@mui/material';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { GenericObject } from '@fnol/library/src/lib';

const OPTIONS_LIMIT = 150;
const filterOptions = createFilterOptions({
    limit: OPTIONS_LIMIT,
});

type AddressComboBoxProps = {
    name: string;
    required: boolean | undefined;
};

const AddressComboBox = (
    props: JSX.IntrinsicAttributes & AutocompleteProps<any, any, any, any> & TextFieldProps & AddressComboBoxProps,
) => {
    const { options, error = false, label, name, defaultValue } = props;
    const { values, setFieldValue } = useFormikContext<GenericObject>();
    const [inputValue, setInputValue] = useState('');
    const [open, setOpen] = useState(false);
    const handleOpen = () => {
        if (inputValue.length > 0) {
            setOpen(true);
        }
    };
    const handleInputChange = (event: SyntheticEvent, newInputValue: string, reason: string) => {
        setInputValue(newInputValue);
        if (newInputValue.length > 0 && reason === 'input') {
            setOpen(true);
        } else {
            setOpen(false);
        }
    };
    const handleChange = (event: SyntheticEvent, newValue: GenericObject) => {
        if (newValue && !newValue.id) {
            const newStreetName = { id: '-1', value: newValue, label: newValue };
            const streetNames = values.streetNames.filter((option: GenericObject) => option.id !== '-1');
            streetNames.push(newStreetName);
            setFieldValue('streetNames', streetNames);
            setTimeout(() => {
                setFieldValue(name, newStreetName);
            });
        } else {
            const streetNames = values.streetNames.filter((option: GenericObject) => option.id !== '-1');
            setFieldValue('streetNames', streetNames);
            setTimeout(() => {
                setFieldValue(name, newValue);
            });
        }
    };
    const onBlur = (e: FocusEvent<HTMLInputElement>) => {
        const streetNameFreeInput = values.streetNames.filter(
            (option: GenericObject) => option.value === e.target.value,
        );
        if (streetNameFreeInput.length > 0) {
            setFieldValue(name, streetNameFreeInput[0]);
        } else {
            const newStreetName = { id: '-1', value: e.target.value, label: e.target.value };
            const streetNames = values.streetNames.filter((option: GenericObject) => option.id !== '-1');
            streetNames.push(newStreetName);
            setFieldValue('streetNames', streetNames);
            setTimeout(() => {
                setFieldValue(name, newStreetName);
            });
        }
    };
    return (
        <Autocomplete
            filterOptions={filterOptions}
            id="combo-box-demo"
            open={open}
            freeSolo
            onOpen={handleOpen}
            onClose={() => setOpen(false)}
            onBlur={onBlur}
            inputValue={inputValue}
            onInputChange={handleInputChange}
            value={defaultValue}
            options={options}
            getOptionLabel={(option: any) => option.label || ''}
            onChange={handleChange}
            renderInput={(params: JSX.IntrinsicAttributes & TextFieldProps) => (
                <TextField {...params} error={error} required={props.required} label={label} />
            )}
        />
    );
};

export default AddressComboBox;